import { createSlice } from '@reduxjs/toolkit';

const MemoriesDataSlice = createSlice({
  name: 'MemoriesData',
  initialState: {
    data: [],
    byTributId: {},
    loading: false
  },
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    info(state, action) {
      const { items, tributId } = action.payload;
      state.data = items;
      if (tributId) {
        state.byTributId[tributId] = items;
      }
      state.loading = false;
    },
    removeMemory(state, action) {
      const { memoryId, tributId } = action.payload || {};
      const memIdNum = Number(memoryId);
      if (Array.isArray(state.data)) {
        state.data = state.data.filter(
          m => Number(m.memoryId) !== memIdNum
        );
      }
      if (tributId && state.byTributId?.[tributId]) {
        state.byTributId[tributId] = state.byTributId[
          tributId
        ].filter(m => Number(m.memoryId) !== memIdNum);
      }
      if (state.byTributId) {
        Object.keys(state.byTributId).forEach(key => {
          if (Array.isArray(state.byTributId[key])) {
            state.byTributId[key] = state.byTributId[key].filter(
              m => Number(m.memoryId) !== memIdNum
            );
          }
        });
      }
    }
  }
});

export const MemoriesDataActions = MemoriesDataSlice.actions;

export default MemoriesDataSlice;
